// extracted by css-extract-rspack-plugin
export default {"transcript":"I9fSJVHbR70EmUHg"};